module.exports = __webpack_public_path__ + "static/media/28DGC6.fadebd2b.jpg";